import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { newAuthService } from "Service/Axios";
import { saveUserProfileUrl } from "Constant/api";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";

const careerOptions = [
  "Researcher",
  "Data Scientist",
  "Software Engineer",
  "Faculty Member",
  "Policy Analyst",
  "Entrepreneur",
];

const lookingForOptions = [
  "Full-time jobs",
  "Internships",
  "Postdoc positions",
  "Research opportunities",
  "Graduate programs",
  "Entrepreneurship support",
];

const availabilityOptions = [
  "Full-time",
  "Part-time",
  "Flexible",
  "Not currently available but open to future opportunities",
];

export const CareerInterestModal = ({ show, toggle, data, fetchData }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    careerGoalText: "",
    careerGoals: [],
    lookingFor: [],
    availabilityDate: null,
    availabilityType: "",
  });

  const {
    careerGoalText,
    careerGoals,
    lookingFor,
    availabilityDate,
    availabilityType,
  } = formData;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeLookingFor = (option) => {
    setFormData((prev) => {
      const updated = prev.lookingFor.includes(option)
        ? prev.lookingFor.filter((item) => item !== option)
        : [...prev.lookingFor, option];

      return {
        ...prev,
        lookingFor: updated,
      };
    });
  };

  const handleChangeCareerGoals = (option) => {
    setFormData((prev) => {
      const updated = prev.careerGoals?.includes(option)
        ? prev.careerGoals.filter((item) => item !== option)
        : [...(prev.careerGoals || []), option];

      return {
        ...prev,
        careerGoals: updated,
      };
    });
  };

  const handleSave = async () => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.careerInterest,
        [VIEW_PROFILE_SECTIONS.careerInterest]: {
          careerGoalText,
          careerGoals,
          lookingFor,
          availabilityDate,
          availabilityType,
        },
      };

      setLoading(true);
      const response = await newAuthService(
        saveUserProfileUrl,
        "POST",
        payload
      );
      if (response.status) {
        toast.success(t("common.messages.notification.success.profileUpdated"));
        fetchData();
        toggle();
      } else {
        toast.error(response.message);
      }
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={toggle} className="highlightsModal">
      <Modal.Header closeButton>
        <Modal.Title className="text-md font-medium">
          {t("auth.viewProfile.editCareerInterest")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row row-gap-3">
          <div className="col-md-12 col-sm-12 col-12">
            <label className="form-label font-medium text-semibold">
              Current Career Goals
            </label>

            <input
              type="text"
              className="form-control mb-2"
              placeholder="Describe your career goals"
              name="careerGoalText"
              value={careerGoalText}
              onChange={handleChange}
            />

            <div className="d-flex flex-column gap-1">
              {careerOptions.map((option) => (
                <div className="form-check" key={option}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={option}
                    value={option}
                    checked={careerGoals.includes(option)}
                    onChange={() => handleChangeCareerGoals(option)}
                  />
                  <label
                    className="form-check-label text-grey-600"
                    htmlFor={option}
                  >
                    {option}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-12">
            <label className="form-label font-medium text-semibold">
              Are you looking for?
            </label>
            <div className="d-flex flex-column gap-1">
              {lookingForOptions.map((option) => (
                <div key={option} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={lookingFor.includes(option)}
                    onChange={() => handleChangeLookingFor(option)}
                    id={option}
                  />
                  <label
                    className="form-check-label text-grey-600"
                    htmlFor={option}
                  >
                    {option}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-12">
            <label className="form-label font-medium text-semibold">
              When are you available to start a new opportunity?
            </label>
            {/* <DatePicker
              selected={availabilityDate}
              onChange={(date) => setAvailabilityDate(date)}
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              className="form-control"
              placeholderText="Select month and year"
            /> */}
            <input
              type="month"
              className="form-control"
              value={availabilityDate}
              name="availabilityDate"
              onChange={handleChange}
              placeholder="Select month and year"
            />
          </div>

          <div className="col-md-12 col-sm-12 col-12">
            <label className="form-label font-medium text-semibold">
              What kind of availability do you have?
            </label>
            {availabilityOptions.map((option) => (
              <div key={option} className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="availabilityType"
                  id={option}
                  value={option}
                  checked={availabilityType === option}
                  onChange={handleChange}
                />
                <label
                  className="form-check-label text-grey-600"
                  htmlFor={option}
                >
                  {option}
                </label>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-light" onClick={toggle} disabled={loading}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={loading}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};
